jQuery.fn.extend({
    exists: function() {
        if (this.length === 0 && console && console.log) {
            console.warn("Element with selector " + this.selector + " was not found.");
        }

        return this;
    }
});